import { render } from "./Community.view.vue?vue&type=template&id=2f006db8"
import script from "./Community.view.vue?vue&type=script&lang=js"
export * from "./Community.view.vue?vue&type=script&lang=js"

import "./Community.view.vue?vue&type=style&index=0&id=2f006db8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__